import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, ArrowRightIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { getImageUrlWithEnv } from '../utils/imageUrl';

const NewsList = ({ news = [], title = "ბოლო ამბები", showAll = true, onRefresh }) => {
  // Debug logging removed
  
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900 font-georgian">{title}</h2>
        <div className="flex items-center space-x-4">
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="text-gray-500 hover:text-primary-600 font-medium font-georgian flex items-center"
              title="განახლება"
            >
              <ArrowPathIcon className="h-4 w-4 mr-1" />
              განახლება
            </button>
          )}
          {showAll && (
            <Link
              to="/news"
              className="text-primary-600 hover:text-primary-700 font-medium font-georgian flex items-center"
            >
              ყველა ამბავი
              <ArrowRightIcon className="h-4 w-4 ml-1" />
            </Link>
          )}
        </div>
      </div>

      <div className="space-y-6">
        {news.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500 font-georgian">ამბები არ არის ხელმისაწვდომი</p>
          </div>
        ) : (
          news.map((article, index) => (
            <article key={index} className="border-b border-gray-200 pb-6 last:border-b-0 last:pb-0">
              <div className="flex flex-col md:flex-row gap-4">
                {/* Article Image */}
                <div className="md:w-48 flex-shrink-0">
                  <div className="w-full h-32 md:h-24 bg-gray-200 rounded-lg overflow-hidden">
                    {article.image ? (
                      <img
                        src={getImageUrlWithEnv(article.image)}
                        alt={article.title}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div className="w-full h-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-2xl" style={{display: article.image ? 'none' : 'flex'}}>
                      FC
                    </div>
                  </div>
                </div>

                {/* Article Content */}
                <div className="flex-1">
                  <div className="flex items-center text-sm text-gray-500 mb-2">
                    <CalendarIcon className="h-4 w-4 mr-1" />
                    <span className="font-georgian">{article.date}</span>
                    {article.category && (
                      <>
                        <span className="mx-2">•</span>
                        <span className="bg-primary-100 text-primary-800 px-2 py-1 rounded-full text-xs font-georgian">
                          {article.category}
                        </span>
                      </>
                    )}
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 font-georgian line-clamp-2">
                    {article.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm font-georgian line-clamp-3 mb-3">
                    {article.excerpt}
                  </p>
                  
                  <Link
                    to={`/news/${article.id}`}
                    className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium text-sm font-georgian"
                  >
                    ვრცლად
                    <ArrowRightIcon className="h-4 w-4 ml-1" />
                  </Link>
                </div>
              </div>
            </article>
          ))
        )}
      </div>
    </div>
  );
};

export default NewsList;
